module.exports = __webpack_public_path__ + "media/brands/harley-davidson-ea8b80e3.png";